import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function MySalary() {
  const navigate = useNavigate();
  const [labour, setLabour]     = useState(null);
  const [months, setMonths]     = useState([]);
  const [selMonth, setSelMonth] = useState("");
  const [salaryData, setSalaryData] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [loadingSalary,  setLoadingSalary]  = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { label:"Dashboard",     emoji:"🏠", path:"/labour/dashboard" },
    { label:"My Attendance", emoji:"📅", path:"/labour/attendance" },
    { label:"My Salary",     emoji:"💰", path:"/labour/salary", active:true },
    { label:"My Payments",   emoji:"💳", path:"/labour/payments" },
    { label:"Profile",       emoji:"👤", path:"/labour/profile" },
  ];

  // ── Fetch profile ─────────────────────────────────────────────
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get("/labour/me");
        setLabour(res.data.labour);
        const ms = [];
        for (let i = 0; i < 6; i++) {
          const d = new Date();
          d.setMonth(d.getMonth() - i);
          ms.push(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`);
        }
        setMonths(ms);
        setSelMonth(ms[0]);
      } catch(e) { console.error(e); }
      finally { setLoadingProfile(false); }
    };
    fetchProfile();
  }, []);

  // ── Fetch salary ──────────────────────────────────────────────
  useEffect(() => {
    if (!labour || !selMonth) return;
    const fetchSalary = async () => {
      setLoadingSalary(true);
      setSalaryData(null);
      try {
        // Always use LIVE preview — calculates directly from attendance
        // This ensures correct data even if carpenter hasn't generated salary
        const previewRes = await api.get(`/salary/preview?month=${selMonth}`);
        if (previewRes.data?.salary) {
          setSalaryData(previewRes.data.salary);
        }
      } catch(e) {
        console.error("Salary preview error:", e);
      } finally {
        setLoadingSalary(false);
      }
    };
    fetchSalary();
  }, [labour, selMonth]);

  const monthLabel = selMonth
    ? new Date(selMonth+"-01").toLocaleDateString("en-IN",{month:"long",year:"numeric"})
    : "";

  const sd = salaryData;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:wght@900&display=swap');
        @keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
        @keyframes spin{to{transform:rotate(360deg)}}
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        body{font-family:'Plus Jakarta Sans',sans-serif;background:#FAF7F4;}
        .sidebar{width:220px;flex-shrink:0;background:#fff;border-right:1.5px solid #E7E5E4;padding:24px 14px;display:flex;flex-direction:column;gap:6px;position:sticky;top:0;height:100vh;overflow-y:auto;}
        .topbar{display:none;}
        .hamburger{display:none;align-items:center;justify-content:center;width:40px;height:40px;border-radius:10px;border:1.5px solid #E7E5E4;background:#fff;cursor:pointer;flex-shrink:0;}
        .sidebar-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:40;}
        .nav-btn{display:flex;align-items:center;gap:9px;width:100%;padding:10px 12px;border-radius:10px;border:none;background:none;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;font-weight:600;color:#78716C;cursor:pointer;transition:background .15s,color .15s;text-align:left;}
        .nav-btn:hover,.nav-btn.active{background:#FEF3C7;color:#D97706;}
        .nav-btn.danger:hover{background:#FEF2F2;color:#DC2626;}
        @media(max-width:768px){
          .sidebar{position:fixed;left:0;top:0;z-index:50;transform:translateX(-100%);transition:transform .28s ease;height:100%;}
          .sidebar.open{transform:translateX(0);}
          .sidebar-overlay.open{display:block;}
          .topbar{display:flex;align-items:center;gap:12px;padding:14px 16px;background:#fff;border-bottom:1.5px solid #E7E5E4;position:sticky;top:0;z-index:30;}
          .hamburger{display:flex;}
          .main-wrap{flex-direction:column!important;}
          .main-content{padding:16px!important;}
        }
        @media(min-width:769px) and (max-width:1100px){.sidebar{width:190px;}}
      `}</style>

      <div className="main-wrap" style={{display:"flex",minHeight:"100vh",fontFamily:"'Plus Jakarta Sans',sans-serif",background:"#FAF7F4"}}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={()=>setSidebarOpen(false)}/>

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"28px",padding:"0 4px"}}>
            <div style={{width:"36px",height:"36px",background:"linear-gradient(135deg,#92400E,#D97706)",borderRadius:"10px",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <span style={{fontSize:"18px"}}>🪚</span>
            </div>
            <div>
              <p style={{fontWeight:"800",fontSize:"15px",color:"#1C1917"}}>Craftigo</p>
              <p style={{fontSize:"11px",color:"#A8A29E",fontWeight:"500"}}>Labour Panel</p>
            </div>
          </div>
          <p style={{fontSize:"11px",fontWeight:"700",color:"#C4B5A4",letterSpacing:"0.7px",textTransform:"uppercase",padding:"0 6px",marginBottom:"6px"}}>Menu</p>
          {navItems.map(n=>(
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`} onClick={()=>{navigate(n.path);setSidebarOpen(false);}}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{flex:1}}/>
          <div style={{padding:"12px",background:"#E0F2FE",borderRadius:"12px",border:"1px solid #BAE6FD",marginBottom:"10px"}}>
            <p style={{fontSize:"12px",fontWeight:"700",color:"#0369A1"}}>🔨 Labour</p>
            <p style={{fontSize:"11px",color:"#0369A1",marginTop:"2px",opacity:.8}}>{labour?.name||"..."}</p>
          </div>
          <button className="nav-btn danger" onClick={()=>{localStorage.clear();navigate("/login");}}>🚪 Logout</button>
        </aside>

        <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0}}>
          {/* TOPBAR */}
          <div className="topbar">
            <button className="hamburger" onClick={()=>setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{fontWeight:"800",fontSize:"16px",color:"#1C1917"}}>💰 My Salary</span>
          </div>

          <main className="main-content" style={{padding:"28px 28px",flex:1,overflowY:"auto"}}>
            <div style={{marginBottom:"20px"}}>
              <h1 style={{fontSize:"24px",fontWeight:"800",color:"#1C1917",letterSpacing:"-0.5px"}}>My Salary</h1>
              <p style={{fontSize:"13px",color:"#A8A29E",marginTop:"3px"}}>Live calculation from your attendance</p>
            </div>

            {/* Month selector */}
            <div style={{background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"14px",padding:"14px 16px",marginBottom:"20px",display:"flex",alignItems:"center",gap:"12px",flexWrap:"wrap"}}>
              <p style={{fontSize:"13px",fontWeight:"700",color:"#44403C"}}>Select Month:</p>
              <select value={selMonth} onChange={e=>setSelMonth(e.target.value)}
                style={{padding:"9px 14px",border:"1.5px solid #E7E5E4",borderRadius:"10px",fontFamily:"'Plus Jakarta Sans',sans-serif",fontSize:"13px",color:"#1C1917",background:"#FFF7ED",outline:"none",cursor:"pointer"}}>
                {months.map(m=>(
                  <option key={m} value={m}>
                    {new Date(m+"-01").toLocaleDateString("en-IN",{month:"long",year:"numeric"})}
                  </option>
                ))}
              </select>
            </div>

            {loadingProfile || loadingSalary ? (
              <div style={{padding:"60px",textAlign:"center"}}>
                <div style={{width:"32px",height:"32px",border:"3px solid #FDE68A",borderTop:"3px solid #D97706",borderRadius:"50%",animation:"spin .7s linear infinite",margin:"0 auto 12px"}}/>
                <p style={{color:"#A8A29E",fontSize:"14px"}}>Calculating salary…</p>
              </div>
            ) : !sd ? (
              <div style={{padding:"60px",textAlign:"center",background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"16px"}}>
                <p style={{fontSize:"36px",marginBottom:"12px"}}>💰</p>
                <p style={{color:"#78716C",fontWeight:"600",fontSize:"15px"}}>No data for {monthLabel}</p>
                <p style={{color:"#A8A29E",fontSize:"13px",marginTop:"6px"}}>No attendance marked for this month yet</p>
              </div>
            ) : (
              <>
                {/* Summary card */}
                <div style={{background:"linear-gradient(135deg,#1C1917,#44403C)",borderRadius:"20px",padding:"24px",marginBottom:"16px",position:"relative",overflow:"hidden"}}>
                  <div style={{position:"absolute",width:"200px",height:"200px",borderRadius:"50%",background:"#D97706",filter:"blur(80px)",opacity:.15,top:"-50px",right:"-50px"}}/>
                  <p style={{fontSize:"12px",fontWeight:"700",color:"#A8A29E",letterSpacing:"1px",textTransform:"uppercase",marginBottom:"6px"}}>{monthLabel} · Salary Summary</p>
                  <p style={{fontFamily:"'Fraunces',serif",fontSize:"36px",fontWeight:"900",color:"#D97706",marginBottom:"4px"}}>
                    ₹{sd.totalSalary||0}
                  </p>
                  <p style={{fontSize:"13px",color:"#78716C"}}>Gross Salary</p>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px",marginTop:"20px"}}>
                    {[
                      {label:"Advance Paid", val:`₹${sd.paidAmount||0}`,      tc:"#A7F3D0", bg:"rgba(5,150,105,.15)"},
                      {label:"Remaining",    val:`₹${sd.remainingAmount||0}`, tc:"#FCA5A5", bg:"rgba(220,38,38,.15)"},
                    ].map(s=>(
                      <div key={s.label} style={{padding:"12px",borderRadius:"12px",background:s.bg,textAlign:"center"}}>
                        <p style={{fontSize:"18px",fontWeight:"800",color:s.tc}}>{s.val}</p>
                        <p style={{fontSize:"11px",color:"#A8A29E",marginTop:"2px"}}>{s.label}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Breakdown */}
                <div style={{background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"16px",padding:"20px",marginBottom:"16px"}}>
                  <p style={{fontSize:"14px",fontWeight:"700",color:"#1C1917",marginBottom:"16px"}}>Salary Breakdown</p>
                  {[
                    {
                      label:"Full Days",
                      sub:`${sd.fullDays||0} days × ₹${sd.dailyRate||0}`,
                      amount:sd.fullAmount||0,
                      color:"#059669",
                      show: true,
                    },
                    {
                      label:"Half Days",
                      sub:`${sd.halfDays||0} days × ₹${(sd.dailyRate||0)/2}`,
                      amount:sd.halfAmount||0,
                      color:"#D97706",
                      show: true,
                    },
                    {
                      label:"Overtime (Attendance)",
                      sub:`${sd.overtimeDays||0} days + ${sd.totalOTHours||0}h extra`,
                      amount:sd.overtimeAttendAmount||0,
                      color:"#0369A1",
                      show: true,
                    },
                    {
                      label:"Overtime (Manual Payments)",
                      sub:"Recorded by carpenter",
                      amount:sd.totalOvertimePay||0,
                      color:"#7C3AED",
                      show: true,
                    },
                    {
                      label:"Total Paid (Advance + Payments)",
                      sub:"All amounts paid so far",
                      amount:-(sd.paidAmount||0),
                      color:"#DC2626",
                      show: true,
                    },
                  ].map((row,i)=>(
                    <div key={row.label} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"11px 0",borderBottom:i<4?"1px solid #F5F5F4":"none"}}>
                      <div>
                        <p style={{fontSize:"13px",fontWeight:"600",color:"#1C1917"}}>{row.label}</p>
                        <p style={{fontSize:"11px",color:"#A8A29E",marginTop:"1px"}}>{row.sub}</p>
                      </div>
                      <span style={{fontSize:"14px",fontWeight:"800",color:row.color}}>
                        {row.amount<0?`-₹${Math.abs(row.amount)}`:`₹${row.amount}`}
                      </span>
                    </div>
                  ))}
                  {/* Net */}
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px",background:"#FAF7F4",borderRadius:"12px",marginTop:"12px",border:"1.5px solid #E7E5E4"}}>
                    <p style={{fontSize:"15px",fontWeight:"800",color:"#1C1917"}}>Net Salary</p>
                    <p style={{fontSize:"20px",fontWeight:"900",color:"#059669"}}>₹{sd.remainingAmount||0}</p>
                  </div>
                </div>

                {/* Rates + Stats */}
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:"12px",marginBottom:"12px"}}>
                  {[
                    {label:"Daily Rate",  val:`₹${sd.dailyRate||0}/day`,    bg:"#FEF3C7",border:"#FDE68A",tc:"#D97706"},
                    {label:"Days Worked", val:`${(sd.fullDays||0)+(sd.halfDays||0)+(sd.overtimeDays||0)} days`, bg:"#D1FAE5",border:"#A7F3D0",tc:"#059669"},
                    {label:"Absent Days", val:`${sd.absentDays||0} days`,   bg:"#FEF2F2",border:"#FECACA",tc:"#DC2626"},
                  ].map(s=>(
                    <div key={s.label} style={{padding:"14px",borderRadius:"14px",background:s.bg,border:`1.5px solid ${s.border}`,textAlign:"center"}}>
                      <p style={{fontSize:"15px",fontWeight:"800",color:s.tc}}>{s.val}</p>
                      <p style={{fontSize:"11px",color:s.tc,opacity:.8,marginTop:"3px"}}>{s.label}</p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </main>
        </div>
      </div>
    </>
  );
}